var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeachersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8661",
    "data-name": "Group 8661",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.001,
    height: 17.001,
    viewBox: "0 0 17.001 17.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3343",
    "data-name": "Path 3343",
    d: "M0,0H17V17H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3344",
    "data-name": "Path 3344",
    d: "M4,15.876a5.667,5.667,0,0,1,11.334,0Zm6.375-4.191v2.775h3.3A4.257,4.257,0,0,0,10.375,11.684ZM8.959,14.459V11.684a4.257,4.257,0,0,0-3.3,2.775ZM9.667,9.5a4.25,4.25,0,1,1,4.25-4.25A4.249,4.249,0,0,1,9.667,9.5Zm0-1.417A2.833,2.833,0,1,0,6.833,5.25,2.833,2.833,0,0,0,9.667,8.084Z",
    transform: "translate(-1.167 -0.292)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachersIcon);
export default __webpack_public_path__ + "static/media/teachersIcon.83056c2b4e90e2d1d5c2c1a87690164f.svg";
export { ForwardRef as ReactComponent };